module.exports = __webpack_public_path__ + "fonts/GillSansProCyrillic-Light.a7ee9aa0.woff2";